module.exports = {
  "country": "UA",
  "artist": "Go_A",
  "song": "Shum",
  "year": "2021",
  "place": "5",
  "spotify": "29bhnde7Gvnp7rvY9zsq5S"
};